import type { PropsWithChildren } from 'react'

import { AppSidebar } from '@/components/AppSidebar'
import { Flash } from '@/components/Flash'
import { SidebarProvider, useSidebar } from '@/lib/sidebar'
import { cn } from '@/lib/utils'

function DashboardShell({ children }: PropsWithChildren) {
  const { collapsed } = useSidebar()

  return (
    <div className="min-h-screen bg-background text-foreground">
      <AppSidebar />
      <Flash />

      <main
        className={cn(
          'min-h-screen transition-[padding] duration-200 ease-out',
          collapsed ? 'pl-16' : 'pl-64',
        )}
      >
        {children}
      </main>
    </div>
  )
}

export function DashboardLayout({ children }: PropsWithChildren) {
  return (
    <SidebarProvider>
      <DashboardShell>{children}</DashboardShell>
    </SidebarProvider>
  )
}
